import { z } from 'zod';

import { BillingFormFieldTypes } from '@features/campaigns/details/components/FormFields/FieldTypes.ts';

export interface OneFlightClientListItem {
  id: string;
  name: string;
}

export interface OneflightParams {
  campaignId: string;
  brandId: string;
}

export interface OneflightBody {
  brandId: string;
}

export const exportOneFlightValidationSchema = z.object({
  [BillingFormFieldTypes.CLIENT]: z
    .string({
      required_error: 'builder.errorMessages.required',
    })
    .nonempty({
      message: 'builder.errorMessages.required',
    }),
  [BillingFormFieldTypes.BRAND]: z
    .string({
      required_error: 'builder.errorMessages.required',
    })
    .nonempty({
      message: 'builder.errorMessages.required',
    }),
});

export type ExportOneflightFormValues = z.infer<typeof exportOneFlightValidationSchema>;
